import { Map } from 'immutable';

import * as PaymentsConstants from '../constants';
import * as D from '../deps';

const INITIAL_STATE = Map({
  [PaymentsConstants.ReducerKeys.SOURCE_ID]: null,
  [PaymentsConstants.ReducerKeys.SOURCE_TYPE]: null,
});

export default D.createReducer(INITIAL_STATE, {
  [PaymentsConstants.Actions.SET_SOURCE]: onSetSource,
});

function onSetSource(state, { payload: { sourceId, sourceType } }) {
  return state.merge({
    [PaymentsConstants.ReducerKeys.SOURCE_ID]: sourceId,
    [PaymentsConstants.ReducerKeys.SOURCE_TYPE]: sourceType,
  });
}
